import React from "react";
import { Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import './App.css';
import MainPage from "./components/MainPage";
import Menupage from "./components/Menupage"; 
import Lockerlocations from "./components/Lockerlocations"; 
import ReservationInfo from "./components/ReservationInfo"; 
import Payment from "./components/Payment"; 
import LockerProcessing from "./components/LockerProcessing"; 
import LockerComplete from "./components/LockerComplete"; 
import PasswordInput from "./components/PasswordInput.js"; 
import DevtoolsBlocker from "./components/DevtoolsBlocker";

function App() {
  const { i18n } = useTranslation();

  return (
  <>
    <Helmet>
      <html lang={i18n.language} />
    </Helmet>

    <DevtoolsBlocker />

    <Routes>
      <Route path="/" element={<MainPage />} />
      <Route path="/Menupage" element={<Menupage />} />
      <Route path="/Lockerlocations/:mainCode" element={<Lockerlocations />} />
      <Route path="/ReservationInfo/:lockerNo" element={<ReservationInfo />} />
      <Route path="/Payment" element={<Payment />} />
      <Route path="/LockerProcessing" element={<LockerProcessing />} />
      <Route path="/LockerComplete" element={<LockerComplete />} />
      <Route path="/PasswordInput/:lockerNo" element={<PasswordInput />} />
    </Routes>
  </>
  );
}

export default App;
